var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWarningToast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-900 -212) translate(886 200) translate(14 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 9,
    y: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14.5,
    r: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWarningToast);
export default __webpack_public_path__ + "static/media/icons-warning-toast.338812c96bb6a77d7dea06c7ba086906.svg";
export { ForwardRef as ReactComponent };